export const OFFLINE_DATA_VERSION = '1';
export const OFFLINE_MENU_VERSION = '1';
export const OFFLINE_TABLES_VERSION = '1';
export const OFFLINE_PUBLIC_TABLE_VERSION = '1';
export const OFFLINE_SETTINGS_VERSION = '1';
